import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { Grid, Paper } from "@mui/material";
import DsokCustomerDetailLayout from "../components/DsokCustomerDetailLayout";
import DsokCustomerDetailDirtySync from "../components/DsokCustomerDetailDirtySync";
import DsokCustomerDetailSectionRegister from "../components/DsokCustomerDetailSectionRegister";
import { useDsokCustomerDetail } from "../data/useDsokCustomerDetail";
import { getSmartkioskInitialValues } from "app/pages/customers/dsok/utils/getSmartkioskInitialValues";
import SmartkioskUISettingsFields, {
  DSOK_UI_SETTINGS_FIELD_NAME,
} from "app/pages/customers/dsok/smartkioskFields/SmartkioskUISettingsFields";

const DsokCustomerUiSettingsPage = () => {
  const { t } = useTranslation();
  const { customer } = useDsokCustomerDetail();

  const formInitialValues = useMemo(() => {
    if (!customer) return { customer: { customerUISettings: {} } };
    const fullInitial = getSmartkioskInitialValues(customer);
    if (!fullInitial || !fullInitial.customer) {
      return {
        customer: {
          customerUISettings:
            customer.dsokSettings?.customer?.customerUISettings || {},
        },
      };
    }
    return { customer: fullInitial.customer };
  }, [customer]);

  const [expanded, setExpanded] = useState(DSOK_UI_SETTINGS_FIELD_NAME);
  const handleChange = (panel) => (_event, _isExpanded) => {
    setExpanded(DSOK_UI_SETTINGS_FIELD_NAME);
  };

  return (
    <DsokCustomerDetailLayout
      lastBreadcrumbLabel={t("pages.dsokDetails.customerUISettings.title")}
    >
      <Paper
        variant="outlined"
        sx={{
          bgcolor: "background.paper",
          p: 2,
          borderRadius: 1,
        }}
      >
        <Formik
          initialValues={formInitialValues}
          enableReinitialize
          onSubmit={() => {}}
        >
          <Form>
            <DsokCustomerDetailDirtySync />
            <DsokCustomerDetailSectionRegister
              sectionId="ui-settings"
              getPayload={(values) => values?.customer?.customerUISettings ?? null}
            />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SmartkioskUISettingsFields
                  handleChange={handleChange}
                  expanded={expanded}
                  hideSectionTitle
                />
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </Paper>
    </DsokCustomerDetailLayout>
  );
};

export default DsokCustomerUiSettingsPage;
